import React, { FC } from 'react';
import { ComingNomenclatureAdjustmentInfoItem } from 'bus/comingNomenclatureAdjustment/types';
import moment from 'moment';

type Props = {
  form: ComingNomenclatureAdjustmentInfoItem;
}

const BlockAdjustmentInfo: FC<Props> = ({
  form
}) => {

  return (
    <div>
        <div className="d-flex">
            <div className="dx-card pl-2 pr-2 pb-2 mb-3 mr-2" style={{ width: 750 }}>
                <div className="info">
                    <div className="info__title">Дата</div>
                    <div className="info__child">{ moment(form?.date).format('DD.MM.YYYY') }</div>
                </div>
                <div className="info">
                    <div className="info__title">Машина</div>
                    <div className="info__child">{ form?.transport }</div>
                </div>
            </div>
            <div className="dx-card pl-2 pr-2 pb-2 mb-3" style={{ width: '100%' }}>
                <div className="info">
                    <div className="info__title">Сумма руб. </div>
                    <div className="info__child">{ form?.sum }</div>
                </div>
                <div className="info">
                    <div className="info__title">Комментарий </div>
                    <div className="info__child">{ form?.comment }</div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default BlockAdjustmentInfo